<fieldset
  motif-file-uploader-container
  class="file-uploader-container"
  [ngClass]="{ error: hasError, 'reduced-width': reducedWidth }"
  [tabIndex]="0"
  (keydown.enter)="triggerFileInput()"
  [attr.aria-activedescendant]="activeDescendant"
  (focus)="onFieldsetFocus()"
  (blur)="onFieldsetBlur()"
>
  <input
    id="custom-uploader"
    #customUploaderInput
    [tabIndex]="-1"
    motif-file-uploader
    aria-label="Upload File"
    [accept]="acceptedFormats"
    (change)="onFileSelected($event)"
    (drop)="onFileDrop($event)"
    (dragover)="allowDrop($event)"
    aria-describedby="upload-status"
  />

  <!-- for accessibility screen reader -->
  @if(file && !hasError){
  <div id="upload-status" aria-live="assertive" class="sr-only">
    File uploaded successfully
  </div>
  }
  <!-- END for accessibility screen reader -->

  <p motif-file-uploader-text>
    @if (file && !hasError) {
    <motif-icon
      size="20"
      class="success-icon"
      [iconFunction]="IconoirCheckCircle"
    ></motif-icon>
    } @else {
    <motif-icon
      class="motif-theme-light"
      size="20"
      [ngClass]="{ error: hasError }"
      [iconFunction]="IconoirCloudUpload"
    ></motif-icon>
    }

    <span [ngClass]="{ error: hasError }">{{
      file && !hasError ? file.name : dropMessage
    }}</span>

    <span [ngClass]="{ error: hasError }">{{
      file && !hasError ? bytesToMB(file.size) + " MB" : allowedFormatsMessage
    }}</span>

    <span>
      <em>
        Make sure that the file is not opened by another app before uploading
        it.
      </em>
    </span>
  </p>

  @if(file){
  <motif-icon
    id="remove-file-btn"
    [tabIndex]="0"
    role="button"
    aria-label="Remove File"
    [iconFunction]="IconoirXmark"
    class="x-mark"
    size="20"
    (click)="resetUploader()"
    (keydown.enter)="resetUploader($event)"
  ></motif-icon>
  }
</fieldset>
